import {
  Button,
  Icon,
} from 'anf-core-react';
import PropTypes from 'prop-types';
import React, {
  useState,
} from 'react';
import useTranslatedText from '../../hooks/useTranslatedText';
import $window from '../../tools/window';
import SearchFlyout from '../SearchFlyout/SearchFlyout';
import SimilarEntryPoint from '../ShopSimilar/SimilarEntryPoint';
import FakeSearchInputField from './FakeSearchInputField';
import style from './searchWrapper.module.scss';

const SearchWrapper = ({
  brand = '',
  searchUrl = '',
  entryType = 'mobile', // 'desktop' or 'mobile'
}) => {
  const [isSearchToasterOpen, setisSearchToasterOpen] = useState(false);

  const handleSearchIconClick = (event) => {
    if ($window.digitalData) {
      $window.digitalData.trigger('universal_click', {
        event_type: 'click',
        data_text: 'Search Icon',
        data_action: 'open',
      }, event);
    }
    setisSearchToasterOpen(true);
  };

  const searchToasterLabel = useTranslatedText('searchToasterLabel', { fallback: 'Open Search' });

  const handleToasterClose = () => {
    setisSearchToasterOpen(false);
  };

  return (
    <>
      <SimilarEntryPoint />
      {entryType === 'desktop' ? (
        <FakeSearchInputField
          buttonLabel="Search"
          handleSearchIconClick={handleSearchIconClick}
        />
      ) : (
        <div
          className={style.wrapper}
          data-testid="search-toaster-button"
        >
          <Button
            classList={style.button}
            onClick={handleSearchIconClick}
            variant="borderless"
          >
            <Icon icon="search" labelText={searchToasterLabel.value} />
          </Button>
        </div>
      )}
      <SearchFlyout
        brand={brand}
        handleModalClose={handleToasterClose}
        isSearchToasterOpen={isSearchToasterOpen}
        searchUrl={searchUrl}
      />
    </>
  );
};

SearchWrapper.propTypes = {
  brand: PropTypes.string,
  searchUrl: PropTypes.string,
  entryType: PropTypes.oneOf(['desktop', 'mobile']),
};

export default SearchWrapper;
